import { type Role } from 'components/Permission/permission.types';
import { appConfiguration } from 'utils/config/app.config';

export const isInternalUser = (role: Role | null) => {
  if (!role) return false;

  return role === 'internal-user';
};

export const isExternalUser = (role: Role | null) => {
  return (role && role === 'external-user') ?? true;
};

// returns true if role is external, updated to cater two new roles
export const isExternalRole = (role: Role) => {
  const allowedRoles = new Set<Role>([
    'external-admin',
    'external-user',
    'external-superadmin',
    'external-director',
  ]);

  return allowedRoles.has(role);
};

// returns true if role is internal
export const isInternalRole = (role: Role) => {
  const allowedRoles = new Set<Role>(['internal-user', 'director']);
  return allowedRoles.has(role);
};

export const hasAccessToMultipleCustomers = (role: Role) => {
  // this is mixed roles which can contain the role for internal as well external users
  if (!role) return false;

  const allowedRoles = new Set<Role>([
    'director',
    'internal-user',
    'external-director',
    'external-superadmin',
  ]);

  if (
    (appConfiguration.isDevelopment || appConfiguration.isStaging) &&
    role === 'developer'
  ) {
    return true;
  }

  return allowedRoles.has(role);
};
